module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9e3X0E/media/FC-9781528902472.jpg?1684514593940",
      "alt": "This image is the cover for the book Betrayal"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Betrayal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Can you mourn someone and despise them at the same time? "), _c('br'), _vm._v("Anna believes she has the perfect life. Happily married with four beautiful children, she is content spending her days looking after her family whilst her husband focuses on his career. "), _c('br'), _vm._v("Stephanie, a career-driven businesswoman, thrives on her independence but is fiercely loyal in her relationship. "), _c('br'), _vm._v("When tragedy strikes one cold December night just before Christmas, it is revealed that Anna and Stephanie’s lives are more entwined than either of them could have ever imagined. Are they both able to overcome lives full of deceit and learn to trust again?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Liane Bayliss\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Liane Bayliss currently resides in Northamptonshire with her husband and three children. "), _c('br'), _vm._v("Her love of writing was firmly engraved with the gift of her first typewriter when she was seven years old. "), _c('br'), _vm._v("Betrayal is Liane’s first novel.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0